import { useNavigate } from "react-router-dom";

interface MyRfiTileProps {
  count: number;
  label: string;
  buttonLabel: string;
  outline?: boolean;
  navigateTo: string;
}

const MyRfiTile = (props: MyRfiTileProps) => {
  const navigate = useNavigate();

  return (

    <div className="text-center">
							<div className="h1 mb-0">{props.count}</div>
							<div className="h6 mb-2">
              {props.label}
							</div>              
							<a href="#" className={props.outline? "btn btn-outline-primary" : "btn btn-primary" } role="button" onClick={() => {
          navigate(props.navigateTo);
        } }>{props.buttonLabel}</a>
		</div>

    
  );
};

export default MyRfiTile;
